<template>
    <div class="recharge-container">
        <p class="recharge-title">Recharge</p>
        <div class="recharge-main">
            <el-form
                ref="rechargeForm"
                :model="rechargeForm"
                label-width="130px"
            >
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            label="Current Balance"
                            prop="goods_name"
                            size="small"
                        >
                            <span class="recharge-num"
                                >$ {{ currentBalance }}</span
                            >
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item size="small">
                            <el-radio-group
                                v-model="amount"
                                size="medium"
                                @change="amountChange"
                            >
                                <el-radio-button
                                    v-for="item in amountList"
                                    :key="item"
                                    :label="item"
                                ></el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row type="flex" :align="middle">
                    <el-col :span="6">
                        <el-form-item
                            label="Amount"
                            prop="goods_name"
                            size="small"
                        >
                            <el-input
                                type="number"
                                clearable
                                placeholder=""
                                maxlength="200"
                                size="small"
                                v-model="num"
                                @change="changeAmount"
                            >
                                <i slot="prefix">$</i>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col
                        :span="6"
                        class="actual-amount-tip"
                        v-show="actualAmount"
                    >
                        <p>
                            Actual amount received:
                            <span style="color: #f04e61"
                                >${{ (num * 0.96).toFixed(2) }}</span
                            >
                        </p>
                    </el-col>
                </el-row>
                <el-form-item
                    label="Payment Voucher"
                    size="small"
                    v-show="['WU', 'Bank'].includes(payMethod)"
                >
                    <div class="oss-upload" :class="{ error: fileRequire }">
                        <ossUpload
                            @imagesChange="imagesChange"
                            :clearFiles.sync="clearFiles"
                        >
                            <span class="oss-upload_tip"
                                ><span>*</span>Compatible file extensions to
                                upload: png, jpg, jpge, pdf
                            </span>
                        </ossUpload>
                    </div>
                </el-form-item>
                <div class="rm-method">
                    <el-radio-group v-model="payMethod">
                        <el-radio label="paypal">
                            <span>Paypal</span>
                        </el-radio>
                        <el-radio label="WU" class="rm-method_radio">
                            <span>Western Union</span>
                            <div
                                class="rm-method_info"
                                v-show="payMethod == 'WU'"
                            >
                                <div class="rm-method_info_item">
                                    <div class="rm-method_info_label">
                                        First Name:
                                    </div>
                                    <div class="rm-method_info_value">
                                        Xian Xi
                                    </div>
                                </div>
                                <div class="rm-method_info_item">
                                    <div class="rm-method_info_label">
                                        Last Name:
                                    </div>
                                    <div class="rm-method_info_value">
                                        Zhang
                                    </div>
                                </div>
                                <div class="rm-method_info_item">
                                    <div class="rm-method_info_label">
                                        City:
                                    </div>
                                    <div class="rm-method_info_value">
                                        Guang Zhou
                                    </div>
                                </div>
                                <div class="rm-method_info_item">
                                    <div class="rm-method_info_label">
                                        Postal Code:
                                    </div>
                                    <div class="rm-method_info_value">
                                        510640
                                    </div>
                                </div>
                                <div class="rm-method_info_item">
                                    <div class="rm-method_info_label">
                                        Country:
                                    </div>
                                    <div class="rm-method_info_value">
                                        China
                                    </div>
                                </div>
                                <div class="rm-method_info_item">
                                    <div class="rm-method_info_label">
                                        Phone:
                                    </div>
                                    <div class="rm-method_info_value">
                                        +86 2085697613
                                    </div>
                                </div>
                            </div>
                        </el-radio>
                        <el-radio label="Bank" class="rm-method_radio">
                            <span>Offline Remittance</span>
                            <div
                                class="rm-method_info"
                                v-show="payMethod == 'Bank'"
                            >
                                <div class="rm-method_info_item">
                                    <div class="rm-method_info_label">
                                        Company Name:
                                    </div>
                                    <div class="rm-method_info_value">
                                        LORAJEWEL LIMITED
                                    </div>
                                </div>
                                <div class="rm-method_info_item">
                                    <div class="rm-method_info_label">
                                        Bank Account:
                                    </div>
                                    <div class="rm-method_info_value">
                                        42152240
                                    </div>
                                </div>
                                <div class="rm-method_info_item">
                                    <div class="rm-method_info_label">
                                        Company Address:
                                    </div>
                                    <div class="rm-method_info_value">
                                        RM12, 20/F HONG KING COMM CTR, 2-16 FA
                                        YUEN ST MONGKOK KLN, HONG KONG
                                    </div>
                                </div>
                                <div class="rm-method_info_item">
                                    <div class="rm-method_info_label">
                                        Bank Name:
                                    </div>
                                    <div class="rm-method_info_value">
                                        CITIBANK (HONG KONG) LIMITED
                                    </div>
                                </div>
                                <div class="rm-method_info_item">
                                    <div class="rm-method_info_label">
                                        Bank Address:
                                    </div>
                                    <div class="rm-method_info_value">
                                        Shop 8, G to 2/F, Wai Fung Plaza, No 664
                                        Nathan Road, Mongkok, Kowloon, Hong Kong
                                    </div>
                                </div>
                                <div class="rm-method_info_item">
                                    <div class="rm-method_info_label">
                                        SWIFT CODE:
                                    </div>
                                    <div class="rm-method_info_value">
                                        CITIHKAX
                                    </div>
                                </div>
                            </div>
                        </el-radio>
                    </el-radio-group>
                </div>
                <div class="rm-tip">
                    <p class="rm-tip_title">Tip：</p>
                    <div class="rm-tip_texts">
                        <p v-for="(item, i) of tipList" :key="item">{{(payMethod === "paypal" ? i+1 +'.': '')}} {{item}}</p>
                    </div>
                </div>
                <el-checkbox v-model="checked"
                    >I understand: The recharge money can only be used for
                    cmoffer consumption</el-checkbox
                >
                <div class="recharge-btn">
                    <el-button
                        type="primary"
                        @click="recharge"
                        :disabled="!checked"
                        :loading="loading"
                        >Recharge</el-button
                    >
                </div>
            </el-form>
        </div>
        <payConfirm
            :paymentVisible.sync="paymentVisible"
            @onClosed="payConfirmClosed"
        ></payConfirm>
    </div>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import ossUpload from "@/common/components/ossUpload.vue";
import payConfirm from "@/common/components/payConfirm.vue";

export default {
    components: {
        ossUpload,
        payConfirm,
    },
    computed: {
        actualAmount() {
            return this.payMethod === "paypal" && this.num > 0;
        },
        tipList() {
            return this.payMethod === "paypal"
                ? [
                      "PayPal fee:  4% of the transaction amount.",
                      "It is recommended to use bank transfer for payment of more than $500.",
                      "After recharging, please settle the payment order in time to avoid affecting the normal service.",
                  ]
                : [
                      "After recharging, please settle the payment order in time to avoid affecting the normal service.",
                  ];
        },
    },
    data() {
        return {
            currentBalance: "0.00",
            rechargeForm: {},
            payMethod: "paypal",
            checked: false,
            amountList: [1000, 3000, 5000],
            amount: "",
            num: "",
            loading: false,
            file: [],
            fileRequire: false,
            clearFiles: false,
            paymentVisible: false,
        };
    },
    methods: {
        recharge() {
            if (
                ["WU", "Bank"].includes(this.payMethod) &&
                this.file.length === 0
            ) {
                this.fileRequire = true;
                return;
            }
            this.loading = true;
            this.$confirm("Confirm to recharge?", "recharge", {
                type: "warning",
            })
                .then(() => {
                    cmofferApi
                        .recharge(
                            {
                                amount: this.num,
                                pay_method: this.payMethod,
                                file: this.file.toString(),
                            },
                            "post"
                        )
                        .then((res) => {
                            this.loading = false;
                            this.$ga.event("ecommerce", "recharge");
                            if (this.payMethod == "paypal") {
                                this.paymentVisible = true;
                                window.open(res.data.links[1].href);
                            } else {
                                if (res.errcode == 0) {
                                    this.amount = "";
                                    this.num = "";
                                    this.payMethod = "";
                                    this.file = [];
                                    this.checked = false;
                                    this.getEntityInfo();
                                    this.$message.success(
                                        this.$i18n.locale == "zh" ? "成功" : "success"
                                    );
                                    this.clearFiles = true;
                                }
                            }

                        });
                })
                .catch(() => {
                    this.$message.info("Recharge failed!");
                    this.loading = false;
                });
        },
        getEntityInfo() {
            cmofferApi.entityInfo({}, "get").then((res) => {
                if (res) {
                    this.currentBalance = res.data.balance;
                }
            });
        },
        imagesChange(img) {
            this.file = img;
            img && (this.fileRequire = false);
        },
        amountChange(val) {
            this.num = val;
        },
        changeAmount() {
            !this.amountList.includes(this.num)
                ? (this.amount = this.num)
                : (this.amount = "");
        },
        payConfirmClosed() {
            console.log(328);
            this.amount = "";
            this.num = "";
            this.payMethod = "";
            this.file = [];
            this.checked = false;
            this.getEntityInfo();
        },
    },
    activated() {
        this.getEntityInfo();
    },
};
</script>


<style lang="scss" scoped>
.recharge-container {
    padding: 15px 30px 110px;
    width: 100%;
    // height: 100%;
    box-sizing: border-box;
    text-align: left;
    .recharge-title {
        font-size: 30px;
        font-weight: 600;
        letter-spacing: 1px;
    }
    .recharge-num {
        font-size: 18px;
        font-weight: 600;
    }
    .recharge-main {
        margin-top: 20px;
        width: 80%;
        min-width: 750px;
        ::v-deep .el-input {
            .el-input__inner {
                padding-right: 0;
            }
        }
        .actual-amount-tip {
            display: flex;
            height: 33px;
            align-items: center;
            margin: 0 0 0 20px;
            font-size: 12px;
            color: #606266;
        }
        .rm-method {
            margin-top: 20px;
            ::v-deep .el-radio-group {
                width: 100%;
                .el-radio {
                    display: flex;
                    align-items: center;
                    padding: 4px 10px;
                    box-sizing: border-box;
                    border: 1px solid #e1e2e3;
                    font-size: 16px;
                    min-height: 40px;
                    background-color: #ffffff;
                    margin-right: 0;
                    .el-radio__label {
                        span {
                            margin-left: 5px;
                        }
                    }
                    & + .el-radio {
                        margin-top: 10px;
                    }
                    &.is-checked {
                        border-color: $color-primary-blue;
                    }
                }
            }
        }
        .rm-tip {
            margin: 20px 0 35px;
            box-sizing: border-box;
            padding: 20px 10px 30px;
            border: 1px solid #e8e8e8;
            background: #f9f9f9;
            font-size: 14px;
            .rm-tip_title {
                margin-bottom: 15px;
            }
            .rm-tip_texts {
                margin-left: 15px;
                p + p {
                    margin-top: 10px;
                }
            }
        }
        .recharge-btn {
            margin: 20px 0 0;
        }
        ::v-deep.rm-method_radio {
            padding: 10px !important;
            align-items: flex-start !important;
            .rm-method_info {
                margin: 20px 0 10px 5px;
                &_item {
                    font-size: 13px;
                    display: flex;
                    align-items: center;
                    color: #606266 !important;
                    user-select: text;
                    &:not(:last-child) {
                        margin: 0 0 12px 0;
                    }
                }
                &_label {
                    font-weight: 600;
                    min-width: 135px;
                }
                &_value {
                    margin: 0 0 0 5px;
                }
            }
        }
        .oss-upload {
            border: 1px solid transparent;
            .oss-upload_tip {
                margin: 0 0 0 20px;
                font-size: 13px;
                span {
                    color: $color-danger;
                }
            }
            &.error {
                padding: 5px;
            }
        }
    }
}
</style>
